const getters = {
  name: state => state.app.name,
  baseColor: state => state.app.baseColor,
  twoColor: state => state.app.twoColor,
}
export default getters
